// StartDateTimeContext.js
import React, { createContext, useContext, useState } from 'react';

const StartDateTimeContext = createContext();

export const StartDateTimeProvider = ({ children }) => {
  const [flags, setFlags] = useState({});
  const [activeScreen, setActiveScreen] = useState({ screenName: '', pathname: '' });
  const [logoutTriggered, setLogoutTriggered] = useState(false);
  const [logoutInProgress, setLogoutInProgress] = useState(false);

  const setFlagForScreen = (uniqueKey, value) => {
    setFlags((prev) => ({ ...prev, [uniqueKey]: value }));
  };

  return (
    <StartDateTimeContext.Provider
      value={{
        flags,
        setFlagForScreen,
        activeScreen,
        setActiveScreen,
        logoutTriggered,
        setLogoutTriggered,
        logoutInProgress,
        setLogoutInProgress,
      }}
    >
      {children}
    </StartDateTimeContext.Provider>
  );
};

export const useStartDateTime = () => useContext(StartDateTimeContext);
